export const name = 'interactions' as const
